import { Navigate } from "react-router-dom";
import { Subtree, useObserver, useSubtree } from "subtree.js/react";
import { pick } from "trunk.js";
import { AppState } from "../../app-controller";
import type { AppDeps } from "../../app-deps";
import { ProfileUnavailable } from "../../components/ProfileUnavailable";
import { DEFAULT_ROUTE } from "../../core/primitives/routes";
import { LoginController } from "./login-controller";
import { LoginPage } from "./login-page";

/**
 * Signing in again cannot fix a profile that fails to load: the credentials
 * are already valid. Say that instead of showing a form that appears to work.
 */
export function LoginRoute({ deps }: { deps: AppDeps }) {
  const state = useSubtree(AppState);
  const observer = useObserver();
  const gate = observer.watch(state.gate);
  if (gate === "signedIn") return <Navigate to={DEFAULT_ROUTE} replace />;
  if (gate === "profileFailed") return <ProfileUnavailable />;
  return (
    <Subtree key="login" controller={() => new LoginController(pick(deps, "session"))}>
      <LoginPage />
    </Subtree>
  );
}
